"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require("./");

exports.default = function (_ref) {
  var black = _ref.black,
      blue = _ref.blue,
      darkGray = _ref.darkGray,
      darkerGray = _ref.darkerGray,
      darkestGray = _ref.darkestGray,
      gray = _ref.gray,
      green = _ref.green,
      lightGray = _ref.lightGray,
      lighterGray = _ref.lighterGray,
      lightestGray = _ref.lightestGray,
      orange = _ref.orange,
      pink = _ref.pink,
      purple = _ref.purple,
      red = _ref.red,
      white = _ref.white,
      yellow = _ref.yellow;
  if (black) return _.BLACK;
  if (blue) return _.BLUE;
  if (darkGray) return _.DARK_GRAY;
  if (darkerGray) return _.DARKER_GRAY;
  if (darkestGray) return _.DARKEST_GRAY;
  if (gray) return _.GRAY;
  if (green) return _.GREEN;
  if (lightGray) return _.LIGHT_GRAY;
  if (lighterGray) return _.LIGHTER_GRAY;
  if (lightestGray) return _.LIGHTEST_GRAY;
  if (orange) return _.ORANGE;
  if (pink) return _.PINK;
  if (purple) return _.PURPLE;
  if (red) return _.RED;
  if (white) return _.WHITE;
  if (yellow) return _.YELLOW;
  return _.COLOR;
};